import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from '../profile.module.scss';
import { connect } from 'react-redux';
import colors from '../../../../utils/colors';
import { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser,
        company: state.common.company,
        connected_account: state.common.connected_account
    };
};

const baseDomain = process.env.REACT_APP_API_URL?.split('api')[1];

const Payment = (props) => {
    const { t } = useTranslation();
    const [onboardingLoader, setOnboardingLoader] = useState(false);
    const [stripeErrorMessage, setStripeErrorMessage] = useState('');
    const history = useHistory();

    return (
        <Box>
            <Typography
                sx={{ marginBottom: '1rem', borderBottom: '1px solid rgba(0, 0, 0, 0.2)' }}
                fontSize={'34px'}>
                {t('Payment')}
            </Typography>
            {props?.connected_account ? (
                <Box className={styles.paymentStripe}>
                    <Typography fontSize={'18px'}>{t('Stripe')}</Typography>
                    {props.connected_account?.onboarded ? (
                        <Box className={styles.flexButtons}>
                            <Button className={styles.connectedButton}>{t('Connected')}</Button>
                            <Button
                                onClick={() => history.push('/onboard')}
                                className={styles.editAccountButton}>
                                {t('EditYourStripeAccount')}
                            </Button>
                        </Box>
                    ) : (
                        <Button
                            onClick={() => history.push('/onboard')}
                            className={styles.notConnectedButton}>
                            {t('PleaseConnectToSell')}
                        </Button>
                    )}
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '1rem'
                    }}>
                    <CircularProgress sx={{ color: colors.primary }} />
                </Box>
            )}
        </Box>
    );
};

export default connect(mapStateToProps, null)(Payment);
